import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2916 12.9275C20.9585 13.106 21.3544 13.7913 21.1758 14.4582C20.7445 16.0692 19.8967 17.5383 18.7176 18.7178C17.5385 19.8973 16.0696 20.7456 14.4587 21.1774C12.8478 21.6092 11.1516 21.6093 9.54067 21.1778C7.92971 20.7462 6.46075 19.8981 5.28146 18.7188L4.23535 17.6717V19.6439C4.23535 20.3343 3.67571 20.8939 2.98535 20.8939C2.295 20.8939 1.73535 20.3343 1.73535 19.6439V14.6519C1.73535 13.9616 2.295 13.4019 2.98535 13.4019H7.97735C8.66771 13.4019 9.22735 13.9616 9.22735 14.6519C9.22735 15.3423 8.66771 15.9019 7.97735 15.9019H6.00111L7.04924 16.9511C7.91812 17.8198 9.00077 18.445 10.1876 18.7629C11.3746 19.0809 12.6245 19.0808 13.8114 18.7626C14.9984 18.4445 16.0807 17.8194 16.9495 16.9503C17.8183 16.0812 18.4431 14.9987 18.7609 13.8117C18.9394 13.1448 19.6248 12.7489 20.2916 12.9275Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70898 11.0724C3.04211 10.8939 2.64624 10.2085 2.82477 9.54167C3.25609 7.93063 4.10392 6.46154 5.28303 5.28206C6.46214 4.10259 7.93097 3.2543 9.54188 2.82249C11.1528 2.39067 12.849 2.39055 14.4599 2.82212C16.0709 3.2537 17.5399 4.10177 18.7191 5.28106L19.7653 6.32816V4.35594C19.7653 3.66559 20.3249 3.10594 21.0153 3.10594C21.7056 3.10594 22.2653 3.66559 22.2653 4.35594V9.34794C22.2653 10.0383 21.7056 10.5979 21.0153 10.5979H16.0233C15.3329 10.5979 14.7733 10.0383 14.7733 9.34794C14.7733 8.65759 15.3329 8.09794 16.0233 8.09794H17.9995L16.9514 7.04882C16.0825 6.18008 14.9998 5.55492 13.813 5.23697C12.626 4.91897 11.3761 4.91906 10.1892 5.23724C9.00219 5.55542 7.91989 6.18047 7.05107 7.04955C6.18225 7.91864 5.55753 9.00114 5.23972 10.1882C5.06118 10.8551 4.37585 11.251 3.70898 11.0724Z"
        fill={colorValue}
      />
    </svg>
  );
};
